import axios from 'axios';
import { getAuthHeader, getErrorMessage, getHost } from '../../util/apiUtil';
import { shouldSee } from '../../util/permissionsUtil';

const SERVICE_TYPES_URL = `${getHost()}/service/types`;

class ServiceTypesApi {
    static getServiceTypes(labelLike = '', includeInactive = true, skip = 0, take = 10) {
        return new Promise((resolve, reject) => {
            if (!shouldSee(['SERVICE_TYPES_READ_MANY'])) {
                console.error('API ERROR | Service Types: User not permitted');
                reject();
            }

            let queriedUrl = `${SERVICE_TYPES_URL}?take=${take}&skip=${skip}&includeInactive=${includeInactive}`;
            if (labelLike.length) {
                queriedUrl += `&labelLike=${labelLike}`;
            }

            axios
                .get(queriedUrl, {
                    headers: getAuthHeader(),
                })
                .then((data) => resolve(data.data))
                .catch((error) => {
                    console.error(`API ERROR | Service Types: ${getErrorMessage(error)}`);
                    reject();
                });
        });
    }

    static getServiceTypeById(id) {
        return new Promise((resolve, reject) => {
            if (!shouldSee(['SERVICE_TYPES_READ'])) {
                console.error('API ERROR | Service Types: User not permitted');
                reject();
            }

            axios
                .get(`${SERVICE_TYPES_URL}/${id}`, {
                    headers: getAuthHeader(),
                })
                .then((data) => resolve(data.data))
                .catch((error) => {
                    console.error(`API ERROR | Service Types: ${getErrorMessage(error)}`);
                    reject();
                });
        });
    }

    static createServiceType(serviceTypeData) {
        return new Promise((resolve, reject) => {
            // TODO: Uncomment when API enabled
            //
            // if (!shouldSee( [''])) {
            //     console.error('API ERROR | Service Types: User not permitted');
            //     reject();
            // }

            axios
                .post(
                    `${SERVICE_TYPES_URL}`,
                    { ...serviceTypeData },
                    {
                        headers: getAuthHeader(),
                    }
                )
                .then((data) => resolve(data.data))
                .catch((error) => {
                    console.error(`API ERROR | Service Types: ${getErrorMessage(error)}`);
                    reject();
                });
        });
    }

    static updateServiceType(serviceTypeData) {
        return new Promise((resolve, reject) => {
            // TODO: Uncomment when API enabled
            //
            // if (!shouldSee( [''])) {
            //     console.error('API ERROR | Service Types: User not permitted');
            //     reject();
            // }

            axios
                .patch(SERVICE_TYPES_URL, { ...serviceTypeData }, { headers: getAuthHeader() })
                .then((data) => resolve(data.data))
                .catch((error) => {
                    console.error(`API ERROR | Service Types: ${getErrorMessage(error)}`);
                    reject();
                });
        });
    }
}
export default ServiceTypesApi;
